module.exports = __webpack_public_path__ + "static/media/reporting1.8cb5c2d4.mp4";